import { render, staticRenderFns } from "./AdministratorPasswordForm.vue?vue&type=template&id=481f568a&"
import script from "./AdministratorPasswordForm.vue?vue&type=script&lang=js&"
export * from "./AdministratorPasswordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports